export const ElectricSearch = [
  {
    name: "mobile",
    label: "手机号码",
    pla: "请输入手机号码",
    type: "input",
  },
  {
    name: "iccid",
    label: "iccid",
    pla: "请输入iccid",
    type: "input",
  },
  {
    name: "name",
    label: "用户名",
    pla: "请输入用户名",
    type: "input",
  },
  {
    name: "operator_id",
    label: "运营商",
    pla: "请选择运营商",
    type: "select",
    dic: "OperatorArr",
  },
];

export const companySearch = [
  {
    name: "name",
    label: "企业名称",
    pla: "请输入企业名称",
    type: "input",
  },
  {
    name: "user_id",
    label: "归属代理商",
    pla: "请选择代理商",
    type: "select",
    dic: "AgentData",
  },
];

export const companySearchNew = [
  {
    name: "name",
    label: "企业名称",
    pla: "请输入企业名称",
    type: "input",
  },
  {
    name: "user_id",
    label: "归属代理商",
    pla: "请选择代理商",
    type: "select",
    dic: "AgentData1",
  },
  {
    name: "black_plat_id",
    label: "防骚扰平台",
    pla: "请选择防骚扰平台",
    type: "select",
    dic: "BlackPlat",
  },
  {
    name: "storm_id",
    label: "风控等级",
    pla: "请选择风控等级",
    type: "select",
    dic: "StormTemp",
  },
  {
    name: "mobile",
    label: "手机号码",
    pla: "请输入手机号码",
    type: "input",
  },
  {
    name: "remark",
    label: "备注",
    pla: "请输入备注",
    type: "input",
  },
];
export const companySearchNew2 = [
  {
    name: "name2",
    label: "企业名称",
    pla: "请输入企业名称",
    type: "input",
  },
  {
    name: "user_id2",
    label: "归属代理商",
    pla: "请选择代理商",
    type: "select",
    dic: "AgentData1",
  },
  {
    name: "black_plat_id2",
    label: "防骚扰平台",
    pla: "请选择防骚扰平台",
    type: "select",
    dic: "BlackPlat",
  },
  {
    name: "storm_id2",
    label: "风控等级",
    pla: "请选择风控等级",
    type: "select",
    dic: "StormTemp",
  },
  {
    name: "mobile2",
    label: "手机号码",
    pla: "请输入手机号码",
    type: "input",
  },
  {
    name: "remark2",
    label: "备注",
    pla: "请输入备注",
    type: "input",
  },
];

export const AuthorizationDetailSearch = [
  {
    name: "id",
    label: "授权ID",
    pla: "请输入授权ID",
    type: "input",
  },
  {
    name: "from",
    label: "派发对象",
    pla: "请选择派发对象",
    type: "select",
    dic: "AgentData",
  },
  {
    name: "to_name",
    label: "使用用户",
    pla: "请输入使用用户名称",
    type: "input",
  },
];

export const billActionSearch = [
  {
    name: "from_name",
    label: "授权操作人",
    pla: "请输入授权操作人",
    type: "input",
  },
  {
    name: "to_name",
    label: "授权对象",
    pla: "请输入授权对象",
    type: "input",
  },
  {
    name: "type",
    label: "类型",
    pla: "请选择类型",
    type: "select",
    dic: "RechargeDeduction",
  },
  {
    name: "call_type_id",
    label: "授权商品",
    pla: "请选择授权商品",
    type: "select",
    dic: "CallTypeList",
  },
];
export const UserbillActionSearch = [
  {
    name: "from",
    label: "代理商",
    pla: "请选择代理商",
    type: "select",
    dic: "AgentData",
  },
  {
    name: "to_name",
    label: "授权对象",
    pla: "请输入授权对象",
    type: "input",
  },
  {
    name: "call_type_id",
    label: "授权商品",
    pla: "请选择授权商品",
    type: "select",
    dic: "CallTypeList",
  },
];
